import apiClient from '../config/api';

const sparePartsService = {
  getParts: async () => {
    const response = await apiClient.get('/spareparts');
    return response.data;
  },

  getPart: async (id) => {
    const response = await apiClient.get(`/spareparts/${id}`);
    return response.data;
  },

  createPart: async (payload) => {
    const response = await apiClient.post('/spareparts', payload);
    return response.data;
  },

  updatePart: async (id, payload) => {
    const response = await apiClient.post(`/spareparts/update/${id}`, payload);
    return response.data;
  },

  deletePart: async (id) => {
    const response = await apiClient.post(`/spareparts/delete/${id}`);
    return response.data;
  },

  recordTransaction: async (id, payload) => {
    const response = await apiClient.post(`/spareparts/${id}/transactions`, payload);
    return response.data;
  },

  getTransactions: async (id, params = {}) => {
    const response = await apiClient.get(`/spareparts/${id}/transactions`, { params });
    return response.data;
  },

  getAlerts: async (params = {}) => {
    const response = await apiClient.get('/spareparts/alerts', { params });
    return response.data;
  },

  getCostSummary: async (params = {}) => {
    const response = await apiClient.get('/spareparts/costs', { params });
    return response.data;
  },

  // ─── Dashboard ───────────────────────────────────────────────────
  getDashboardSummary: async () => {
    const response = await apiClient.get('/inventory/dashboard/summary');
    return response.data;
  },

  getStockTrend: async () => {
    const response = await apiClient.get('/inventory/dashboard/stock-trend');
    return response.data;
  },

  getMovementChart: async () => {
    const response = await apiClient.get('/inventory/dashboard/movement-chart');
    return response.data;
  },

  getTopParts: async () => {
    const response = await apiClient.get('/inventory/dashboard/top-parts');
    return response.data;
  },

  getVendorCostDistribution: async () => {
    const response = await apiClient.get('/inventory/dashboard/vendor-cost');
    return response.data;
  },

  // ─── History ─────────────────────────────────────────────────────
  getInventoryHistory: async (params = {}) => {
    const response = await apiClient.get('/inventory/history', { params });
    return response.data;
  },

  // ─── Reports ─────────────────────────────────────────────────────
  getLowStockReport: async () => {
    const response = await apiClient.get('/inventory/reports/low-stock');
    return response.data;
  },

  getOverstockReport: async () => {
    const response = await apiClient.get('/inventory/reports/overstock');
    return response.data;
  },

  getValuationReport: async () => {
    const response = await apiClient.get('/inventory/reports/valuation');
    return response.data;
  },

  getMovementReport: async (params = {}) => {
    const response = await apiClient.get('/inventory/reports/movement', { params });
    return response.data;
  },
};

export default sparePartsService;
